let ClientQuicksightUatURL = () => {
    let client = localStorage.getItem('customerNumber');

    switch (client) {
        case "549":
            return {
                "LR_PROFITABILITY_REPORT": 'ed6d2c60-0823-487d-8b8b-546b189ebc7c',
            }
        default: //1158 Client
            return {}
    }
}

export default ClientQuicksightUatURL();